module.exports = __webpack_public_path__ + "assets/img/saules-logo-small.9cfa36cc.webp";